import axios from '../helpers/axios'
import { logError } from '../services';
import { IFieldWalkthroughManagementLocation, IFieldWalkthroughManagementLocationDetail, IFieldWalkthroughManagementLocationDetailPayload, IFieldWalkthroughManagementLocationPayload, IResponse } from '../models';

export const getFieldWalkthroughManagementLocations = async (filters?: {
    page?: number;
    perPage?: number | string;
    sortBy?: string;
    sortDirection?: string;
    name?: string;
    showOnlyActive?: boolean;
  }): Promise<IResponse<IFieldWalkthroughManagementLocation[]>> => {
    try {
      const { data } = await axios.get(`/api/field-walkthrough-location-management`, {
        params: filters
      });
      return data;
    } catch (error) {
      logError(error, 'getFieldWalkthroughLocations failed');
      return Promise.reject(error?.response?.data);
    }
  };

  export const createFieldWalkthroughManagementLocation = async (payload: IFieldWalkthroughManagementLocationPayload): Promise<number> => {
    try {
      const { data } = await axios.post(`/api/field-walkthrough-location-management`, payload);
      return data;
    } catch (error) {
      logError(error, 'createFieldWalkthroughManagementLocation failed');
      return Promise.reject(error?.response?.data);
    }
  };

  export const getFieldWalkthroughManagementLocation = async (locationId: string): Promise<IFieldWalkthroughManagementLocationDetail> => {
    try {
      const { data } = await axios.get(`/api/field-walkthrough-location-management/${locationId}`,);
      return data;
    } catch (error) {
      logError(error, 'getFieldWalkthroughManagementLocation failed');
      return Promise.reject(error?.response?.data);
    }
  };

  export const updateFieldWalkthroughManagementLocationItems = async (locationId: string, payload: IFieldWalkthroughManagementLocationDetailPayload): Promise<any> => {
    try {
      const { data } = await axios.put(`/api/field-walkthrough-location-management/${locationId}`, payload);
      return data;
    } catch (error) {
      logError(error, 'updateFieldWalkthroughManagementLocationItems failed');
      return Promise.reject(error?.response?.data);
    }
  };

  export const getFieldWalkthroughManagementLocationItems = async (locationId: string): Promise<string[]> => {
    try {
      const { data } = await axios.get(`/api/field-walkthrough-location-management/${locationId}/items`);
      return data;
    } catch (error) {
      logError(error, 'getFieldWalkthroughManagementLocationItems failed');
      return Promise.reject(error?.response?.data);
    }
  };
